export { default } from './BancoDoAutoPesado25Banner';
